export enum LogLevel {
  ERROR = 0,
  INFO,
  DEBUG,
}
